import React, { useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

const GlassDoor: React.FC<Props> = ({ onComplete }) => {
  useEffect(() => {
    const t = setTimeout(onComplete, 1550);
    return () => clearTimeout(t);
  }, [onComplete]);

  const panelBase = {
    backdropFilter: 'blur(0px)',
    WebkitBackdropFilter: 'blur(0px)',
  };

  const sheen = (left: string) => ({
    position: 'absolute' as const,
    top: 0,
    left,
    width: '12%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.35) 50%, transparent 100%)',
    transform: 'skewX(-6deg)',
    pointerEvents: 'none' as const,
  });

  const handle = (side: 'left' | 'right') => ({
    position: 'absolute' as const,
    [side]: '10%',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '5px',
    height: '68px',
    background: 'linear-gradient(180deg, #c9a84c 0%, #d4af37 50%, #b8960c 100%)',
    borderRadius: '3px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.22)',
  });

  const backplate = (side: 'left' | 'right', offset: string) => ({
    position: 'absolute' as const,
    [side]: offset,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '16px',
    height: '84px',
    background: 'rgba(212,175,55,0.10)',
    borderRadius: '4px',
    border: '1px solid rgba(212,175,55,0.28)',
  });

  return (
    <div className="fixed inset-0 z-50 flex overflow-hidden">
      {/* Left door */}
      <div
        className="door-left relative w-1/2 h-full"
        style={{
          ...panelBase,
          transformOrigin: 'left center',
          background: 'linear-gradient(135deg, #f5f0ea 0%, #ede6dc 45%, #f2ede6 100%)',
          borderRight: '1px solid rgba(212,175,55,0.6)',
          boxShadow: 'inset -4px 0 16px rgba(212,175,55,0.12), 4px 0 24px rgba(0,0,0,0.12)',
        }}
      >
        <div style={sheen('16%')} />
        <div style={sheen('52%')} />
        <div style={handle('right')} />
        <div style={backplate('right', 'calc(10% - 6px)')} />
      </div>

      {/* Right door */}
      <div
        className="door-right relative w-1/2 h-full"
        style={{
          ...panelBase,
          transformOrigin: 'right center',
          background: 'linear-gradient(225deg, #f5f0ea 0%, #ede6dc 45%, #f2ede6 100%)',
          borderLeft: '1px solid rgba(212,175,55,0.6)',
          boxShadow: 'inset 4px 0 16px rgba(212,175,55,0.12), -4px 0 24px rgba(0,0,0,0.12)',
        }}
      >
        <div style={sheen('30%')} />
        <div style={handle('left')} />
        <div style={backplate('left', 'calc(10% - 6px)')} />
      </div>
    </div>
  );
};

export default GlassDoor;
